import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'
import {ColorLinearProgress} from '../App'
import {localization} from '../Frames/localization'
import Paper from '@material-ui/core/Paper';

import { ThemeProvider } from "@material-ui/styles";
import {ThemeTab} from '../../src/App'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {ThemeSwitch} from '../../src/App'
//progress
import CircularProgress from '@material-ui/core/CircularProgress';
//info
import SnackbarContent from '@material-ui/core/SnackbarContent';
import clsx from 'clsx';
import { amber, green } from '@material-ui/core/colors';

import InputText from "../Elements/TextField/InputText";

import { authenticationService } from '../Authorization/_services';
//icons
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ListIcon from '@material-ui/icons/List';
//Table 
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Button from "../Elements/Button/buttons";
import { Divider } from '@material-ui/core';
import {
    StyledTableCellPadding,
    StyledTableRow
} from '../Elements/constantComponent'
import './transferMoney.css'

import {themeColorText} from '../../src/App'
//AppBar
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

//settings
import {AppliedSettings} from '../../src/App' 
import Transaction from './transaction'

class TransferMoney extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            TabNotAvailable: false,
            value: 0,
            valueSum: null,
            typeFuel: false,
            //source
            card_source: null,
            listByCard_source: null,
            dataClient_source: null,
            ItemSelected_source: null,
            AccountItemSelected_source: null,
            ItemFilterSkus_source: null,
            dataSelectedWallet_source: null,

            //receiver
            card_receiver: null,
            listByCard_receiver: null,
            dataClient_receiver: null,
            ItemSelected_receiver: null,
            AccountItemSelected_receiver: null,
            ItemFilterSkus_receiver: null,

            progress: false,
            progressButton: false,

            key: undefined,
            res: Array, 
            isLoaded: false,
        }
        this.componentDidMount = this.componentDidMount.bind(this)
        this.handleChange = this.handleChange.bind(this);

        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangeTypeTransfer = this.onChangeTypeTransfer.bind(this);
        
        this.handleSelectAccount_source = this.handleSelectAccount_source.bind(this);
        this.handleSelectSubAccount_source = this.handleSelectSubAccount_source.bind(this);
        this.handleSelectAccount_filterSkus_source = this.handleSelectAccount_filterSkus_source.bind(this);
        this.handleSelectSubAccount_receiver = this.handleSelectSubAccount_receiver.bind(this);
        this.handleSelectAccount_receiver = this.handleSelectAccount_receiver.bind(this);
        this.handleSelectAccount_filterSkus_receiver = this.handleSelectAccount_filterSkus_receiver.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.validateFunds = this.validateFunds.bind(this);
        this.validateFuel = this.validateFuel.bind(this);
        this.setDataFunds = this.setDataFunds.bind(this);
        this.setDataFuel = this.setDataFuel.bind(this);

    }
    componentDidMount()
    {
        this.props.setSelectedIndex(3);
        this.getDataClient(authenticationService.currentUserValue.data.id);
        this.ApplyFundsFuelForm()
    }
    ApplyFundsFuelForm()
    {
        if(AppliedSettings.transfer_allow_funds_form === true & AppliedSettings.transfer_allow_fuel_form === true)
        {
            this.setState({typeFuel: false})
        }else if(AppliedSettings.transfer_allow_funds_form === true & AppliedSettings.transfer_allow_fuel_form === false)
        {
            this.setState({typeFuel: false})
        }else if(AppliedSettings.transfer_allow_funds_form === false & AppliedSettings.transfer_allow_fuel_form === true){
            this.setState({typeFuel: true})
        }
    }
    handleChange = (event, newValue) => {
        this.setState({value: newValue});
      };
    async getDataClient(id, notReload)
    {
        if(id === null || id === "") 
        {
            this.setState({dataClient_source: null, ItemSelected_source: null, AccountItemSelected_source: null, ItemFilterSkus_source: null})
            this.setState({dataClient_receiver: null, ItemSelected_receiver: null, AccountItemSelected_receiver: null, ItemFilterSkus_receiver: null})
            return;
        }
        const requestOptionsExit_body = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: id
            })
        }
        var response = await fetch('/client/getData', requestOptionsExit_body)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
            }
            return response.json()})

        var FisrtSelectFilterSkus = null;
        response.data.accounts.map((item, index)=>{
            if(FisrtSelectFilterSkus != null)
            {
                return null;
            }
            if(item.type === 1)
            {
                FisrtSelectFilterSkus = index;
            }
            return null;
        })
        if(!notReload)
        {
            this.setState({
                ItemFilterSkus_source: FisrtSelectFilterSkus, 
                ItemFilterSkus_receiver: FisrtSelectFilterSkus})
        }
        this.setState({dataClient_source: response.data,
            dataClient_receiver: response.data})
        this.setState({isLoaded: true, progress: false})
    }
    onChangeTypeTransfer()
    {
        const {typeFuel} = this.state;
        this.setState({typeFuel: !typeFuel,
        //source
        ItemSelected_source: null,
        AccountItemSelected_source: null,
        //receiver
        ItemSelected_receiver: null,
        AccountItemSelected_receiver: null,
    })
    }
    getSubAccountSchemaText(x)
    {
        if (x && x.schema === 1) return ` (${localization.GetTranslate('TransferMoney.on account')})`;
        return "";
    }
    handleSelectAccount_source(index)
    {
        this.setState({
            AccountItemSelected_source: index,
            ItemSelected_source: null,
            dataSelectedWallet_source: null
        })
    }
    handleSelectSubAccount_source(index, item)
    {
        this.setState({
            ItemSelected_source: index,
            AccountItemSelected_source: null,
            dataSelectedWallet_source: item})
    }
    handleSelectAccount_filterSkus_source(index)
    {
        this.setState({
            ItemFilterSkus_source: index,
            AccountItemSelected_source: null,
            ItemSelected_source: null
        })
    }
    handleSelectSubAccount_receiver(index)
    {
        this.setState({
            ItemSelected_receiver: index,
            AccountItemSelected_receiver: null})
    }
    handleSelectAccount_receiver(index)
    {
        this.setState({
            AccountItemSelected_receiver: index,
            ItemSelected_receiver: null
        })
    }
    handleSelectAccount_filterSkus_receiver(index)
    {
        this.setState({
            ItemFilterSkus_receiver: index,
            AccountItemSelected_receiver: null,
            ItemSelected_receiver: null
        })
    }
    onChangeValue(event)
    {
        this.setState({valueSum: event.target.value});
    }
    async onSubmit(event)
    {
        event.preventDefault();
        const {typeFuel} = this.state;
        if(typeFuel?!this.validateFuel():!this.validateFunds())
        {
            return;
        }
        await this.setState({progressButton: true})
        var data = typeFuel?this.setDataFuel():this.setDataFunds();
        
        const requestOptionsExit_body = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        var response = await fetch(typeFuel?'/operation/transferFuel':'/operation/transferFunds', requestOptionsExit_body)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
            return response.json()})
        if(response.data === null)
        {
            messageWindow.OpenMessage("error", localization.GT(response.error.replace(/[.:"]/g, '')))
            this.setState({progressButton: false, key: Math.random()})
            return;
        }
        messageWindow.OpenMessage("success", `${localization.GetTranslate('TransferMoney.TransferSuccess')}. ID: ${response.data.data}`)
        this.setState({progressButton: false,  key: Math.random(), valueSum: null})
        this.getDataClient(authenticationService.currentUserValue.data.id, true);
    }
    setDataFunds()
    {
        const {valueSum} = this.state;
        const {listByCard_source, dataClient_source, ItemSelected_source, AccountItemSelected_source} = this.state;
        const {listByCard_receiver, dataClient_receiver, ItemSelected_receiver, AccountItemSelected_receiver} = this.state;
        var Ac_subAc_Id = ItemSelected_receiver !== null?
        (dataClient_receiver?dataClient_receiver.subAccounts[ItemSelected_receiver].id:listByCard_receiver[ItemSelected_receiver].id):
        dataClient_receiver.accounts[AccountItemSelected_receiver].id;
        var body = {
            amount: valueSum,
            dstSubAccount: {
               clientId: authenticationService.currentUserValue.data.id,
            },
            header: {
                accountId: AccountItemSelected_source !== null?dataClient_source.accounts[AccountItemSelected_source].id:undefined,
                clientId: authenticationService.currentUserValue.data.id,
                comment: "",
                date: new Date(),
                // locationId: fields.locationId,
                // operatorId: fields.operatorId,
                subAccountId: ItemSelected_source !== null?
                (dataClient_source?dataClient_source.subAccounts[ItemSelected_source].id:listByCard_source[ItemSelected_source].id):undefined
            }
        }
        if(ItemSelected_receiver !== null)
        {
            body.dstSubAccount.subAccountId = Ac_subAc_Id;
        }else
        {
            body.dstSubAccount.accountId = Ac_subAc_Id;
        }
        return body;
    }
    setDataFuel()
    {
        const {valueSum} = this.state;
        const {listByCard_source, dataClient_source, ItemSelected_source, AccountItemSelected_source} = this.state;
        const {listByCard_receiver, dataClient_receiver, ItemSelected_receiver, AccountItemSelected_receiver} = this.state;
        var Ac_subAc_Id = ItemSelected_receiver !== null?
        (dataClient_receiver?dataClient_receiver.subAccounts[ItemSelected_receiver].id:listByCard_receiver[ItemSelected_receiver].id):
        dataClient_receiver.accounts[AccountItemSelected_receiver].id;
        var body = {
            quantity: valueSum,
            skuId: ItemSelected_source !== null?
            (dataClient_source?dataClient_source.subAccounts[ItemSelected_source].skuId:listByCard_source[ItemSelected_source].skuId):
            (dataClient_source.accounts[AccountItemSelected_source].skuId),
            dstSubAccount: {
               clientId: authenticationService.currentUserValue.data.id,
            },
            header: {
                accountId: AccountItemSelected_source !== null?dataClient_source.accounts[AccountItemSelected_source].id:undefined,
                clientId: authenticationService.currentUserValue.data.id,
                comment: "",
                date: new Date(),
                // locationId: fields.locationId,
                // operatorId: fields.operatorId,
                subAccountId: ItemSelected_source !== null?
                (dataClient_source?dataClient_source.subAccounts[ItemSelected_source].id:listByCard_source[ItemSelected_source].id):undefined
            }
        }
        if(ItemSelected_receiver !== null)
        {
            body.dstSubAccount.subAccountId = Ac_subAc_Id;
        }else
        {
            body.dstSubAccount.accountId = Ac_subAc_Id;
        }
        return body;
    }
    validateFunds()
    {
        const {valueSum} = this.state;
        const {ItemSelected_source, AccountItemSelected_source, dataSelectedWallet_source} = this.state;
        const {ItemSelected_receiver, AccountItemSelected_receiver} = this.state;
        
        if(AccountItemSelected_source === null)
        {
            if(ItemSelected_source === null)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.chooseWallets'))
                this.setState({key: Math.random()})
                return false;
            }
            if(dataSelectedWallet_source !== null)
            {
                if(dataSelectedWallet_source.maxAllowedByLimit !== "")
                {
                    if(valueSum > parseFloat(dataSelectedWallet_source.maxAllowedByLimit, 10))
                    {
                        messageWindow.OpenMessage("error", localization.GT('Достигнут предел списания'))
                        this.setState({key: Math.random()})
                        return false;
                    }
                }
                
            }
        }
        if(AccountItemSelected_receiver === null)
        {
            if(ItemSelected_receiver === null)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.chooseWallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }

        if(ItemSelected_source !== null & ItemSelected_receiver !== null)
        {
            if(ItemSelected_source === ItemSelected_receiver)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.Transfer is allowed only between different accounts-wallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }

        if(AccountItemSelected_source !== null & AccountItemSelected_receiver !== null)
        {
            if(AccountItemSelected_source === AccountItemSelected_receiver)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.Transfer is allowed only between different accounts-wallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }
        if(valueSum <= 0)
        {
          messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.The value must be greater than zero'))
          this.setState({key: Math.random()})
          return false;
        }
          
        return true;
    }
    validateFuel()
    {
        const {valueSum} = this.state;
        const {listByCard_source, dataClient_source, ItemSelected_source, AccountItemSelected_source, dataSelectedWallet_source} = this.state;
        const {listByCard_receiver, dataClient_receiver, ItemSelected_receiver, AccountItemSelected_receiver} = this.state;
        if(AccountItemSelected_source === null)
        {
            if(ItemSelected_source === null)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.chooseWallets'))
                this.setState({key: Math.random()})
                return false;
            }
            if(dataSelectedWallet_source !== null)
            {
                if(dataSelectedWallet_source.maxAllowedByLimit !== "")
                {
                    if(valueSum > parseFloat(dataSelectedWallet_source.maxAllowedByLimit, 10))
                    {
                        messageWindow.OpenMessage("error", localization.GT('Достигнут предел списания'))
                        this.setState({key: Math.random()})
                        return false;
                    }
                }
                
            }
        }
        if(AccountItemSelected_receiver === null)
        {
            if(ItemSelected_receiver === null)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.chooseWallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }
        if(valueSum <= 0)
        {
            messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.The value must be greater than zero'))
            this.setState({key: Math.random()})
            return false;
        }
        let skuId_source, skuId_receiver = null;
        if(listByCard_source !== null)
        {
            skuId_source = listByCard_source[ItemSelected_source].skuId;
        }
        if(dataClient_source !== null)
        {
            if(AccountItemSelected_source === null)
            {
                skuId_source = dataClient_source.subAccounts[ItemSelected_source].skuId;
            }else
            {
                skuId_source = dataClient_source.accounts[AccountItemSelected_source].skuId;
            }
        }

        if(listByCard_receiver !== null)
        {
            skuId_receiver = listByCard_receiver[ItemSelected_receiver].skuId;
        }
        if(dataClient_receiver !== null)
        {
            if(AccountItemSelected_receiver === null)
            {
                skuId_receiver = dataClient_receiver.subAccounts[ItemSelected_receiver].skuId;
            }else
            {
                skuId_receiver = dataClient_receiver.accounts[AccountItemSelected_receiver].skuId;
            }
        }
        if(skuId_source !== skuId_receiver)
        {
            messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.The source nomenclature must match the destination nomenclature'))
            this.setState({key: Math.random()})
            return false;
        }
        if(ItemSelected_source !== null & ItemSelected_receiver !== null)
        {
            if(ItemSelected_source === ItemSelected_receiver)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.Transfer is allowed only between different accounts-wallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }
        if(AccountItemSelected_source !== null & AccountItemSelected_receiver !== null)
        {
            if(AccountItemSelected_source === AccountItemSelected_receiver)
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('TransferMoney.Transfer is allowed only between different accounts-wallets'))
                this.setState({key: Math.random()})
                return false;
            }
        }
        return true;
    }
    RenderDataClientAccounts(dataClient, AccountItemSelected, handleSelectAccount, type)
    {
        if(!AppliedSettings.transfer_allow_accounts)
        {
            return null;
        }
        const ItemFilterSkus = type === "source"?this.state.ItemFilterSkus_source:this.state.ItemFilterSkus_receiver;
        return <React.Fragment>
            <TableContainer className='TableContainerTransfer' style={{overflowX: 'hidden'}} component={Paper}>
            <Typography className="TypographyNameFormsStats" variant="h6">{localization.GetTranslate("TransferMoney.accounts")}</Typography>
            <Table className="TransferTable" stickyHeader style={{minHeight: '600px !important'}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    {!this.state.typeFuel &&
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.remainder")}</StyledTableCellPadding>
                    }
                    {this.state.typeFuel &&
                    <React.Fragment>
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.Nomenclature")}</StyledTableCellPadding>
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.remainder")}</StyledTableCellPadding>
                    </React.Fragment>
                    }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dataClient.accounts.map((item, index)=>(
                        <React.Fragment>
                        {!this.state.typeFuel &&
                        <React.Fragment>
                        {item.type === 0 &&
                            <StyledTableRow
                            className="list-in-Forms"
                            classes={{
                                selected: "list-in-Forms-selection"
                            }}
                            onClick={()=> handleSelectAccount(index)}
                            selected={AccountItemSelected === index}
                            key={index}>
                            <TableCell>
                                {item.balance + this.getSubAccountSchemaText(item)}
                            </TableCell>
                            </StyledTableRow>
                        }
                        </React.Fragment>
                        }
                        {this.state.typeFuel &&
                        <React.Fragment>
                        {item.type === 1 &&
                            <React.Fragment>
                            {ItemFilterSkus !== null &&
                            <React.Fragment>
                                {dataClient.accounts[ItemFilterSkus].skuIdDesc === item.skuIdDesc &&
                                    <StyledTableRow
                                    className="list-in-Forms"
                                    classes={{
                                        selected: "list-in-Forms-selection"
                                    }}
                                    onClick={()=> handleSelectAccount(index)}
                                    selected={AccountItemSelected === index}
                                    key={index}>
                                    <TableCell className="ObjectTableCellStats">
                                        {item.skuIdDesc}
                                    </TableCell>
                                    <TableCell className="ObjectTableCellStats">
                                        {item.balance + this.getSubAccountSchemaText(item)}
                                    </TableCell>
                                    </StyledTableRow>
                                }
                            </React.Fragment>
                            }
                            </React.Fragment>
                        }
                        </React.Fragment>
                        }
                        </React.Fragment>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    }
    RenderDataClientWallets(dataClient, ItemSelected, AccountItemSelected, handleSelectSubAccount, type)
    {
        if(!AppliedSettings.transfer_allow_wallets)
        {
            return null;
        }
        const ItemFilterSkus = type === "source"?this.state.ItemFilterSkus_source:this.state.ItemFilterSkus_receiver;
        return <React.Fragment>
            <TableContainer className='TableContainerTransfer' style={{overflowX: 'hidden'}} component={Paper}>
            <Typography className="TypographyNameFormsStats" variant="h6">{localization.GetTranslate("TransferMoney.subAccounts")}</Typography>
            <Table className="TransferTable" stickyHeader style={{minHeight: '600px !important'}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    {!this.state.typeFuel &&
                    <React.Fragment>
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.card")}</StyledTableCellPadding>
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.remainder")}</StyledTableCellPadding>
                        <StyledTableCellPadding className="TableCell" align='center'>{localization.GetTranslate("TransferMoney.Available")}</StyledTableCellPadding>
                    </React.Fragment>
                    }
                    {this.state.typeFuel &&
                        <React.Fragment>
                            <StyledTableCellPadding className="TableCell" align='center' >{localization.GetTranslate("TransferMoney.Nomenclature")}</StyledTableCellPadding>
                            <StyledTableCellPadding className="TableCell" align='center' >{localization.GetTranslate("TransferMoney.card")}</StyledTableCellPadding>
                            <StyledTableCellPadding className="TableCell" align='center' >{localization.GetTranslate("TransferMoney.remainder")}</StyledTableCellPadding>
                            <StyledTableCellPadding className="TableCell" align='center' >{localization.GetTranslate("TransferMoney.Available")}</StyledTableCellPadding>
                        </React.Fragment>
                    }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dataClient.subAccounts.map((item, index)=>(
                        <React.Fragment>
                        {!this.state.typeFuel &&
                        <React.Fragment>
                        {item.type === 0 &&
                            <StyledTableRow
                            className="list-in-Forms"
                            classes={{
                                selected: "list-in-Forms-selection"
                            }}
                            onClick={()=> handleSelectSubAccount(index, item)}
                            selected={ItemSelected === index}
                            key={index}>
                            <TableCell>
                                {item.externalCardCode}
                            </TableCell>
                            <TableCell>
                                {item.balance + this.getSubAccountSchemaText(item)}
                            </TableCell>
                            <TableCell>
                                {item.maxAllowedByLimit}
                            </TableCell>
                            </StyledTableRow>
                        }</React.Fragment>
                        }
                        {this.state.typeFuel &&
                        <React.Fragment>
                        {item.type === 1 &&
                        <React.Fragment>
                            {ItemFilterSkus !== null &&
                            <React.Fragment>
                            {dataClient.accounts[ItemFilterSkus].skuIdDesc === item.skuIdDesc &&
                                <StyledTableRow
                                className="list-in-Forms"
                                classes={{
                                    selected: "list-in-Forms-selection"
                                }}
                                onClick={()=> handleSelectSubAccount(index, item)}
                                selected={ItemSelected === index}
                                key={index}>
                                <TableCell className="ObjectTableCellStats">
                                    {item.skuIdDesc}
                                </TableCell>
                                <TableCell className="ObjectTableCellStats">
                                    {item.externalCardCode}
                                </TableCell>
                                <TableCell className="ObjectTableCellStats">
                                    {item.balance + this.getSubAccountSchemaText(item)}
                                </TableCell>
                                <TableCell className="ObjectTableCellStats">
                                    {item.maxAllowedByLimit}
                                </TableCell>
                                </StyledTableRow>
                            }
                            </React.Fragment>
                            }
                        </React.Fragment>
                        }
                        </React.Fragment>
                        }
                        </React.Fragment>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
            {AccountItemSelected === null &&
                <React.Fragment>
                    {ItemSelected !== null &&
                        <MySnackbarContentWrapper
                        variant="success"
                        message={`${localization.GetTranslate('TransferMoney.Card wallet selected')} ${dataClient.subAccounts[ItemSelected].externalCardCode}`}
                        />
                    }
                    {ItemSelected === null &&
                        <MySnackbarContentWrapper
                        variant="warning"
                        message={localization.GetTranslate('TransferMoney.chooseWallets')}
                        />
                    }
                </React.Fragment>
            }
            {AccountItemSelected !== null &&
                <MySnackbarContentWrapper
                variant="success"
                message={localization.GetTranslate('TransferMoney.chooseAccount')}
                />
            }
        </React.Fragment>
    }
    RenderListByCard(listByCard, ItemSelected, handleSelectSubAccount)
    {
        return <React.Fragment>
            <TableContainer className='TableContainerTransfer' style={{overflowX: 'hidden'}} component={Paper}>
            <Table className="TransferTable" stickyHeader style={{minHeight: '600px !important'}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <StyledTableCellPadding align='center' className="ObjectTableCellStatsHead">{localization.GetTranslate("TransferMoney.remainder")}</StyledTableCellPadding>
                        <StyledTableCellPadding align='center' className="ObjectTableCellStatsHead">{localization.GetTranslate("TransferMoney.Available")}</StyledTableCellPadding>
                    </TableRow>
                </TableHead>
                {listByCard !== null &&
                <TableBody>
                    {listByCard.map((item, index)=>(
                        <React.Fragment>
                        {item.type === 0 &&
                            <StyledTableRow
                            className="list-in-Forms"
                             classes={{
                                 selected: "list-in-Forms-selection"
                             }}
                             onClick={()=> handleSelectSubAccount(index, item)}
                             selected={ItemSelected === index}
                             key={index}>
                            <TableCell className="ObjectTableCellStats">
                                {item.balance + this.getSubAccountSchemaText(item)}
                            </TableCell>
                            <TableCell className="ObjectTableCellStats">
                                {item.maxAllowedByLimit}
                            </TableCell>
                            </StyledTableRow>
                        }
                        </React.Fragment> 
                    ))}
                </TableBody>
                }
                </Table>
            </TableContainer>
            {ItemSelected !== null &&
                <MySnackbarContentWrapper
                variant="success"
                message={localization.GetTranslate('TransferMoney.Card wallet selected')}
            />
            }
            {ItemSelected === null &&
                <MySnackbarContentWrapper
                variant="warning"
                message={localization.GetTranslate('TransferMoney.chooseWallets')}
            />
            }
        </React.Fragment>
    }
    RenderDataFilterSkus(dataClient, ItemSelected, handleSelect)
    {
        if(this.state.typeFuel === false)
        {
            return;
        }
        return <React.Fragment>
            <br></br>
        <TableContainer style={{overflowX: 'hidden'}} component={Paper}>
        <Typography className="TypographyNameFormsStats" variant="h6">{localization.GetTranslate("TransferMoney.Nomenclature")}</Typography>
        <Table stickyHeader style={{minHeight: '600px !important'}} aria-label="simple table">
            <TableHead>
                <TableRow>
                    {/* <StyledTableCellPadding align='center' className="ObjectTableCellStatsHead">{localization.GT("editObject.Nomenclature")}</StyledTableCellPadding> */}
                </TableRow>
            </TableHead>
            <TableBody>
                {dataClient.accounts.map((item, index)=>(
                    <React.Fragment>
                    {item.type === 1 &&
                        <StyledTableRow
                        className="list-in-Forms"
                        classes={{
                            selected: "list-in-Forms-selection"
                        }}
                        onClick={()=> handleSelect(index)}
                        selected={ItemSelected === index}
                        key={index}>
                        <TableCell className="ObjectTableCellStats">
                            {item.skuIdDesc}
                        </TableCell>
                        </StyledTableRow>
                    }
                    </React.Fragment>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
    </React.Fragment>
    }
    RenderDataFilterSkusCard(listByCard, ItemSelected, handleSelect)
    {
        if(this.state.typeFuel === false)
        {
            return;
        }
        return <React.Fragment>
            <br></br>
        <TableContainer style={{overflowX: 'hidden'}} component={Paper}>
        <Typography className="TypographyNameFormsStats" variant="h6">{localization.GetTranslate("TransferMoney.Nomenclature")}</Typography>
        <Table stickyHeader style={{minHeight: '600px !important'}} aria-label="simple table">
            <TableHead>
                <TableRow>
                    {/* <StyledTableCellPadding align='center' className="ObjectTableCellStatsHead">{localization.GT("editObject.Nomenclature")}</StyledTableCellPadding> */}
                </TableRow>
            </TableHead>
            <TableBody>
                {listByCard.map((item, index)=>(
                    <React.Fragment>
                    {item.type === 1 &&
                        <StyledTableRow
                        className="list-in-Forms"
                        classes={{
                            selected: "list-in-Forms-selection"
                        }}
                        onClick={()=> handleSelect(index)}
                        selected={ItemSelected === index}
                        key={index}>
                        <TableCell className="ObjectTableCellStats">
                            {item.skuIdDesc}
                        </TableCell>
                        </StyledTableRow>
                    }
                    </React.Fragment>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
    </React.Fragment>
    }
    hideForms()
    {
        if(AppliedSettings.transfer_allow_funds_form === false & AppliedSettings.transfer_allow_fuel_form === false)
        {
            return false
        }else
        {
            return true
        }
    }
    render() {
        const {isLoaded, res, progress, TabNotAvailable,
            dataClient_source,
            AccountItemSelected_source,
            ItemSelected_source,
            listByCard_source,
            card_source,
            ItemFilterSkus_source,

            dataClient_receiver,
            AccountItemSelected_receiver,
            ItemSelected_receiver,
            listByCard_receiver,
            card_receiver,
            ItemFilterSkus_receiver,

            value,
            valueSum,
            typeFuel,
            progressButton
        } = this.state;

        return(
            <div>
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            } 
            <div className="containers" style={{marginTop: 0}}> 
            <MessageWindow key={this.state.key} ></MessageWindow> 
                {!isLoaded && TabNotAvailable == false &&
                    <div class="preloader"></div> 
                }
                {isLoaded &&
                <div>
                    <ThemeProvider theme={ThemeTab}>
                    <AppBar style={{position: 'fixed',zIndex:5}} position="static" color="default" className="AppBar">
                        <Tabs
                        className="TabsBG"
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        TabIndicatorProps = { {
                            style : {
                              backgroundColor :  AppliedSettings.transfer_tab_color
                           }
                         } }
                        textColor="primary"
                        variant="standart"
                        aria-label="full width tabs example"
                        >
                        {AppliedSettings.transfer_show_transfer_tab &&
                        <Tab className="TabTransfer" label={<label style={{marginLeft: 30, cursor: 'pointer'}}>{localization.GetTranslate('TransferMoney.Transfer')}</label>} icon={<AccountBalanceWalletIcon className="iconTabs"/>}  {...a11yProps(0)} />
                        }
                        {AppliedSettings.transfer_show_transaction_tab &&
                        <Tab className="TabTransfer" label={<label style={{marginLeft: 20, cursor: 'pointer'}}>{localization.GetTranslate('TransferMoney.Transaction')}</label>} icon={<ListIcon className="iconTabs"/>} {...a11yProps(1)} />
                        }
                        </Tabs>
                    </AppBar>
                </ThemeProvider>
                {AppliedSettings.transfer_show_transfer_tab &&
                <TabPanel value={value} index={0} style={{marginTop: 0}}>
                {this.hideForms() &&
                <React.Fragment>
                {AppliedSettings.transfer_allow_funds_form & AppliedSettings.transfer_allow_fuel_form &&
                <Grid className="CheckBoxGrid" container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <FormControlLabel control={
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>{localization.GetTranslate('TransferMoney.transferFunds')}</Grid>
                            <Grid item>
                                <ThemeSwitch 
                                        onClick={this.onChangeTypeTransfer}
                                        checked={typeFuel}
                                        color="primary"
                                        />
                            </Grid>
                            <Grid item>{localization.GetTranslate('TransferMoney.transferFuel')}</Grid>
                        </Grid>}/>
                    </Grid>
                </Grid>
                }
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                        <Paper className="TransferBox">
                        <div className={"TransferTable"}>                            
                                <MySnackbarContentWrapper
                                variant="info"
                                message={localization.GetTranslate('TransferMoney.source')}
                                />
                            {dataClient_source !== null &&
                                this.RenderDataFilterSkus(dataClient_source, ItemFilterSkus_source, this.handleSelectAccount_filterSkus_source)
                            }    
                            <br></br>
                            {dataClient_source !== null &&
                                this.RenderDataClientAccounts(dataClient_source, AccountItemSelected_source, this.handleSelectAccount_source, "source")
                            }
                            <br></br>
                            {dataClient_source !== null &&
                                this.RenderDataClientWallets(dataClient_source, ItemSelected_source, AccountItemSelected_source, this.handleSelectSubAccount_source, "source")
                            }
                            <br></br>
                            {/* CARD */}
                            {card_source !== null &&
                                this.RenderDataFilterSkusCard(listByCard_source, ItemFilterSkus_source, this.handleSelectAccount_filterSkus_source)
                            }
                            <br></br>
                            {card_source !== null &&
                                this.RenderListByCard(listByCard_source, ItemSelected_source, this.handleSelectSubAccount_source, "source")
                            }
                            <Divider />
                            <InputText 
                            key={this.state.key}
                            id="sum"
                            name="sum"
                            onChange={this.onChangeValue}
                            value={valueSum}
                            inputProps={{min: 0}}
                            type="number"
                            label={localization.GetTranslate('TransferMoney.sum')}
                            margin="normal"
                            variant="outlined"
                            className="InputLimits"
                            classNamelabel="InputLimitsLabel"
                            />
                        </div>
                        </Paper>    
                    </Grid>
                    <Grid item xs={"auto"}>
                    <Paper className="TransferBox">
                        <div className={"TransferTable"}>
                                <MySnackbarContentWrapper
                                variant="info"
                                message={localization.GetTranslate('TransferMoney.receiver')}
                                />
                            {dataClient_receiver !== null &&
                                this.RenderDataFilterSkus(dataClient_receiver, ItemFilterSkus_receiver, this.handleSelectAccount_filterSkus_receiver)
                            }
                            <br></br>
                            {dataClient_receiver !== null &&
                                this.RenderDataClientAccounts(dataClient_receiver, AccountItemSelected_receiver, this.handleSelectAccount_receiver, "receiver")
                            }
                            <br></br>
                            {dataClient_receiver !== null &&
                                this.RenderDataClientWallets(dataClient_receiver, ItemSelected_receiver, AccountItemSelected_receiver, this.handleSelectSubAccount_receiver, "receiver")
                            }
                            <br></br>
                            {/* CARD */}
                            {card_receiver !== null &&
                                this.RenderDataFilterSkusCard(listByCard_receiver, ItemFilterSkus_receiver, this.handleSelectAccount_filterSkus_receiver)
                            }
                            <br></br>
                            {card_receiver !== null &&
                                this.RenderListByCard(listByCard_receiver, ItemSelected_receiver, this.handleSelectSubAccount_receiver, "receiver")
                            }
                            <form onSubmit={this.onSubmit}>
                                <Divider />                             
                                <Button
                                    variant="contained"
                                    type="submit"
                                    value="submit"
                                    color="primary"
                                    textLabel={progressButton?<CircularIndeterminate/>:localization.GetTranslate('TransferMoney.Transfering')}
                                    className="SaveButtonTransfer"
                                    disabled={progressButton}
                                >
                                </Button>                           
                            </form>
                        </div>
                        </Paper>
                    </Grid>
                </Grid>
                </React.Fragment>
                }
                </TabPanel>
                }
                {AppliedSettings.transfer_show_transaction_tab &&
                <TabPanel value={value} index={Boolean(AppliedSettings.transfer_show_transfer_tab)?1:0} style={{marginTop: 0}}>
                    <Grid className="CheckBoxGrid" container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Transaction></Transaction>
                    </Grid>
                </Grid>
                </TabPanel>
                }
                </div>
                }             
            </div>
            </div>
        );

    }
}
const useStyles = makeStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: themeColorText.color,
      margin: 'auto'
    },
    warning: {
      backgroundColor: amber[700],
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
  }));
function MySnackbarContentWrapper(props) {
    const classes = useStyles();
    const { className, message, messageValue, onClose, variant, ...other } = props;
  
    return (
      <SnackbarContent
        className={clsx(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <div style={{textAlign:'center'}}>
          <span className="messageWarnText" style={{fontWeight: 'bold', textAlign:'center'}} >
            {message}
          </span>
          </div>
        }
        {...other}
      />
    );
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
  const useStylesProgress = makeStyles((theme) => ({
    root: {
      display: 'flex', 
    },
    colorPrimary: {
        color: `${AppliedSettings.progress_bar_color} !important`,
      },
  }));
  function CircularIndeterminate() {
    const classes = useStylesProgress();
  
    return (
      <div className={classes.root}>
        <CircularProgress
        classes={{
            colorPrimary: classes.colorPrimary,
        }}
        size={25}/>
      </div>
    );
  }
export default TransferMoney;

